<script>
    import MetaService from '../services/api/MetaService'

    export default {
        name: "Meta",
        data(){
            return {
                metaService: MetaService,
                metaData: {
                    mt: '',
                    md: '',
                    mk: '',
                    header: ''
                }
            }
        },
        methods: {
            getMetaData() {
                if(!this.metaUrl) return false;

                MetaService.setLocale(this.$store.state.language.appLanguage);
                MetaService.getMeta(this.metaUrl)
                    .then((res) => {
                        this.metaData = res.data;
                        this.updateMeta()
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            updateMeta(){
                document.querySelector('title').text = this.metaData.mt;
                document.querySelector('meta[name="description"]').setAttribute('content', this.metaData.md);
                //document.querySelector('meta[name="keywords"]').setAttribute('content', this.metaData.mk);
            }
        },
        mounted() {
            this.getMetaData(this.metaUrl);
        }
    }
</script>
